if (typeof pillsLoaded === 'undefined') {
  var pillsLoaded = true;
  $(document).ready(function () {
    $('.image-with-text__pills').on('mouseenter', '.js-pill-trigger', function() {
      const $trigger = $(this);
      if ($trigger.hasClass('link--pill-active') == false) {
        const indexToShow = $trigger.attr("data-index");
        const $parent = $trigger.closest('.image-with-text');

        $parent.find('.link--pill-active').removeClass('link--pill-active');
        $trigger.addClass('link--pill-active');

        $parent.find('.pill-panel--active').removeClass('pill-panel--active');
        $parent.find(`.pill-panel[data-index="${indexToShow}"]`).addClass('pill-panel--active');
      }

    });

  });

}
